<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REGISTRO DE FOLIOS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>                
            </v-card-text>
            <modal-ayuda></modal-ayuda>

         <!-- tabla producción -->
            <v-card-text>
                <v-card class="mt-2">
                    <template>
                        <v-tabs
                            fixed-tabs
                            background-color="cyan darken-3"
                            dark
                            v-model="tab"
                            height="min-content"
                        >
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                            <v-tab key="fol_prod">
                                <v-card-title>
                                    Folio Producción
                                </v-card-title>
                            </v-tab>
                            <v-tab key="fol_dest">
                                <v-card-title>
                                    Folio Destino
                                </v-card-title>
                            </v-tab>
                            <v-tab key="fol_abas">
                                <v-card-title>
                                    Folio Abas. Aceite
                                </v-card-title>
                            </v-tab>
                            <v-tab key="fol_dest_aceite">
                                <v-card-title>
                                    Folio Dest. Aceite
                                </v-card-title>
                            </v-tab>
                            <v-tab key="fol_harina">
                                <v-card-title>
                                    Folios Harina
                                </v-card-title>
                            </v-tab>
                        </v-tabs>
                    </template>

                    <v-tabs-items v-model="tab">
                        <template v-for="tab in tabs_info">
                            <tab-folio
                                :tab_key="tab.tab_key"
                                :url_datos="tab.url_datos"
                                :url_actualizar="tab.url_actualizar"
                                :cabeceras="tab.cabeceras"
                                :nombre_folio="tab.nombre_folio"
                                :extra="tab.extra"
                            ></tab-folio>
                        </template>
                    </v-tabs-items>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapState } from 'vuex';
// Tabs
import TabFolio from './TabFolio.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data() {
        return {
            tab: null,
            bodegas: [],
            lotes: [],
        }
    },
    mounted() {
        this.cargarBodegas("bodega");
        this.cargarLotes();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Registro de Folios`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se pueden registrar los distintos folios que se registran en el sistema, de forma que sea más fácil completar los folios de aquellos movimientos que no se les registró el folio en su momento. En cada sección de esta pantalla se pueden filtrar por fechas y si es que solo se desea buscar los registros sin folios ingresados. Al buscar los registros, se debe pulsar en el icono del lápiz de la columna "Opciones" para activar la opción de cambiar o ingresar el folio correspondiente, este se actualizará al momento de pulsar enter o pulsar fuera del cuadro de texto del folio. Las secciones son:`},
                {   tipo:`label`,   texto:`- Folio Producción: adicionalmente, se debe indicar tipo de producción (Harina o Aceite), y se muestra un listado de todas las producciones ingresadas.`},
                {   tipo:`label`,   texto:`- Folio Destino: adicionalmente, se debe indicar tipo de producción (Harina o Aceite), y se muestra un listado de todos los despachos ingresados.`},
                {   tipo:`label`,   texto:`- Folio Abas. Aceite: es únicamente para ingresar folios de abastecimiento de Aceite, y se muestra un listado de todos los despachos de aceite que requieren folio de abastecimiento.`},
                {   tipo:`label`,   texto:`- Folio Dest. Aceite: es únicamente para ingresar folios de destino de Aceite, y se muestra un listado de todos los movimientos de aceite que requieren folio de destino.`},
                {   tipo:`label`,   texto:`- Folios Harina: es únicamente para ingresar folios de Harina (el folio en concreto se mostrará en cada registro), y se muestra un listado de todos los movimientos de harina que requieren su respectivo folio.`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarBodegas(tipo_bodega){
            const url = `${this.base_url}bodega?tipo_bodega=${tipo_bodega}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                console.log(this.bodegas);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarLotes(){
            const url = `${this.base_url}lotes_externos`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.lotes = res.data.data;
                console.log(this.lotes);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
    },
    computed: {
        tabs_info() {
            return [
                {
                    tab_key: "fol_prod",
                    url_datos: `${this.base_url}folios/buscar_produccion`,
                    url_actualizar: `${this.base_url}folios/folio_produccion`,
                    nombre_folio: "folio_produccion",
                    cabeceras: [
                        { text: 'ID',        align: 'center',    sortable: true,     value: 'id',             class: 'cabecera',},
                        { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
                        { text: 'Lineas',       align: 'center',    sortable: true,     value: 'nombre_linea',     class: 'cabecera',},
                        { text: 'Tipo de Producción',      align: 'center',    sortable: true,     value: 'tipo_produccion',    class: 'cabecera',},
                        { text: 'Tipo de Materia Prima', align: 'center',    sortable: true,     value: 'tipo_materia_prima',      class: 'cabecera',},
                        { text: 'Producción',         align: 'center',    sortable: true,     value: 'produccion',              class: 'cabecera',},
                        { text: 'Variable',     align: 'center',    sortable: true,     value: '',          class: 'cabecera',},
                        { text: 'Folio de Producción',     align: 'center',    sortable: true,     value: 'folio',          class: 'cabecera',},
                        { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
                    ],
                },
                {
                    tab_key: "fol_desp",
                    url_datos: `${this.base_url}folios/buscar_despachos`,
                    url_actualizar: `${this.base_url}folios/folio_destino`,
                    nombre_folio: "folio_destino",
                    cabeceras: [
                        { text: 'ID',        align: 'center',    sortable: true,     value: 'id',             class: 'cabecera',},
                        { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
                        { text: 'Guia',       align: 'center',    sortable: true,     value: 'guia',     class: 'cabecera',},
                        { text: 'Tipo de Producción',      align: 'center',    sortable: true,     value: 'tipo_produccion',    class: 'cabecera',},
                        { text: 'Kilos Romana', align: 'center',    sortable: true,     value: 'kilos_romana',      class: 'cabecera',},
                        { text: 'Bodega destino',         align: 'center',    sortable: true,     value: 'bodega_destino',              class: 'cabecera',},
                        { text: 'Folio destino',     align: 'center',    sortable: true,     value: 'folio',          class: 'cabecera',},
                        { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
                    ],
                    extra: {
                        bodegas: this.bodegas,
                        valores_modificables: ['bodega_destino'],
                    }
                },
                {
                    tab_key: "fol_abas",
                    url_datos: `${this.base_url}folios/buscar_despachos_abastecimiento`,
                    url_actualizar: `${this.base_url}folios/folio_abastecimiento`,
                    nombre_folio: "folio_abastecimiento",
                    cabeceras: [
                        { text: 'ID',        align: 'center',    sortable: true,     value: 'id',             class: 'cabecera',},
                        { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
                        { text: 'Patente',       align: 'center',    sortable: true,     value: 'patente',     class: 'cabecera',},
                        { text: 'Bodega destino',         align: 'center',    sortable: true,     value: 'bodega_destino',              class: 'cabecera',},
                        { text: 'Guia',       align: 'center',    sortable: true,     value: 'guia',     class: 'cabecera',},
                        { text: 'Estanque', align: 'center',    sortable: true,     value: 'estanque',      class: 'cabecera',},
                        { text: 'Lote Aceite',     align: 'center',    sortable: true,     value: 'lote_aceite',          class: 'cabecera',},
                        { text: 'Litros',     align: 'center',    sortable: true,     value: 'litros',          class: 'cabecera',},
                        { text: 'Folio abastecimiento',     align: 'center',    sortable: true,     value: 'folio',          class: 'cabecera',},
                        { text: 'Observaciones',     align: 'center',    sortable: true,     value: 'observaciones',          class: 'cabecera',},
                        { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
                    ],
                    extra: {
                        bodegas: this.bodegas,
                        lotes: this.lotes,
                        valores_modificables: ['lotes_aceite_id', 'observaciones'],
                        sin_tipo_produccion: true,
                    }
                },
                {
                    tab_key: "fol_dest_aceite",
                    url_datos: `${this.base_url}folios/buscar_folio_destino_aceite`,
                    url_actualizar: `${this.base_url}folios/folio_destino_aceite`,
                    nombre_folio: "folio_destino",
                    cabeceras: [
                        { text: 'ID',        align: 'center',    sortable: true,     value: 'id',             class: 'cabecera',},
                        { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
                        { text: 'Nro. Embarque',       align: 'center',    sortable: true,     value: 'nro_embarque',     class: 'cabecera',},
                        { text: 'Guia',       align: 'center',    sortable: true,     value: 'guia',     class: 'cabecera',},
                        { text: 'Bodega origen',         align: 'center',    sortable: true,     value: 'bodega_origen',              class: 'cabecera',},
                        { text: 'Bodega destino',         align: 'center',    sortable: true,     value: 'bodega_destino',              class: 'cabecera',},
                        { text: 'Folio destino', align: 'center',    sortable: true,     value: 'folio',      class: 'cabecera',},
                        { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
                    ],
                    extra: {
                        bodegas: this.bodegas,
                        sin_tipo_produccion: true,
                    }
                },
                {
                    tab_key: "fol_harina",
                    url_datos: `${this.base_url}folios/buscar_folios_harina`,
                    url_actualizar: `${this.base_url}folios/folio_harina`,
                    nombre_folio: "valor_folio",
                    cabeceras: [
                        { text: 'ID',        align: 'center',    sortable: true,     value: 'id',             class: 'cabecera',},
                        { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
                        { text: 'Tipo movimiento',       align: 'center',    sortable: true,     value: 'tipo_movimiento',     class: 'cabecera',},
                        { text: 'Motivo movimiento',       align: 'center',    sortable: true,     value: 'motivo_movimiento',     class: 'cabecera',},
                        { text: 'Bodega origen',         align: 'center',    sortable: true,     value: 'bodega_origen',              class: 'cabecera',},
                        { text: 'Bodega destino',         align: 'center',    sortable: true,     value: 'bodega_destino',              class: 'cabecera',},
                        { text: 'Guia',       align: 'center',    sortable: true,     value: 'guia',     class: 'cabecera',},
                        { text: 'Observaciones',       align: 'center',    sortable: true,     value: 'observaciones',     class: 'cabecera',},
                        { text: 'Folio', align: 'center',    sortable: true,     value: 'folio',      class: 'cabecera',},
                        { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
                    ],
                    extra: {
                        bodegas: this.bodegas,
                        valores_modificables: ['observaciones'],
                        sin_tipo_produccion: true,
                    }
                },
            ];
        },
        ...mapState(['base_url', 'headers', 'roles']),
    },
    components: {
        'tab-folio': TabFolio,
        'modal-ayuda': ModalAyudas,
    }
}
</script>

<style>
</style>